import {
  GET_PROJECTED_RETURN,
  GET_PROJECTED_RETURN_SUCCESS,
  GET_PROJECTED_RETURN_FAILED,
  STEP_STARTED,
  GET_TOTAL_UNIT_FUNDS,
  GET_TOTAL_UNIT_FUNDS_SUCCESS,
  GET_TOTAL_UNIT_FUNDS_FAILED,
  PROJECTED_RETURN_INVEST,
  PROJECTED_RETURN_INVEST_SUCCESS,
  PROJECTED_RETURN_INVEST_FAILED,
  UPDATE_CUSTOMER_DUPLICATE,
  UPDATE_CUSTOMER_DUPLICATE_SUCCESS,
  UPDATE_CUSTOMER_DUPLICATE_FAILED,
  GET_RETIREMENT_MIN_AMOUNT,
  GET_RETIREMENT_MIN_AMOUNT_SUCCESS,
  GET_RETIREMENT_MIN_AMOUNT_FAILED,
  GET_RETIREMENT_MAX_AMOUNT,
  GET_RETIREMENT_MAX_AMOUNT_SUCCESS,
  GET_RETIREMENT_MAX_AMOUNT_FAILED,
  GET_RETIREMENT_CARD_INFO,
  GET_RETIREMENT_CARD_INFO_SUCCESS,
  GET_RETIREMENT_CARD_INFO_FAILED,
  GET_MAX_RETIREMENT_YEAR_SUCCESS,
  GET_MAX_RETIREMENT_YEAR_FAILED,
  GET_MIN_RETIREMENT_YEAR,
  GET_MAX_RETIREMENT_YEAR,
  GET_MIN_RETIREMENT_YEAR_SUCCESS,
  GET_MIN_RETIREMENT_YEAR_FAILED,
} from "./constant";
import { ENV_SAVE } from "./constant";

const initialState = {
  startedStep: ENV_SAVE,
  totalUnitFunds: { itemCount: 20 },
  saveProjectedReturnValue: "3.95%",
  saveInceptionDate: "2025-06-30",
  investProjectedReturnValue: "22.14%",
  investInceptionDate: "2025-01-31",
  retirementMinAmount: process.env.REACT_APP_RETIREMENT_MIN_AMOUNT.trim(),
  retirementMaxAmount: process.env.REACT_APP_RETIREMENT_MAX_AMOUNT.trim(),
  retirementProjectedReturn: "10.04%",
  retirementInceptiondate: "2024-09-30",
  minRetirementYear: process.env.REACT_APP_MIN_RETIREMENT_YEAR.trim(),
  maxRetirementYear: process.env.REACT_APP_MAX_RETIREMENT_YEAR.trim(),
};

export default function getStartedReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MIN_RETIREMENT_YEAR:
      return {
        ...state,
        getMinRetirementYearLoading: true,
      };
    case GET_MIN_RETIREMENT_YEAR_SUCCESS:
      return {
        ...state,
        getMinRetirementYearLoading: false,
        minRetirementYear: action.payload?.value,
      };
    case GET_MIN_RETIREMENT_YEAR_FAILED:
      return {
        ...state,
        getMinRetirementYearLoading: false,
        minRetirementYear: process.env.REACT_APP_MIN_RETIREMENT_YEAR.trim(),
      };
    case GET_MAX_RETIREMENT_YEAR:
      return {
        ...state,
        getMaxRetirementYearLoading: true,
      };
    case GET_MAX_RETIREMENT_YEAR_SUCCESS:
      return {
        ...state,
        getMaxRetirementYearLoading: false,
        maxRetirementYear: action.payload?.value,
      };
    case GET_MAX_RETIREMENT_YEAR_FAILED:
      return {
        ...state,
        getMaxRetirementYearLoading: false,
        maxRetirementYear: process.env.REACT_APP_MAX_RETIREMENT_YEAR.trim(),
      };
    case GET_RETIREMENT_CARD_INFO:
      return {
        ...state,
        getRetirementCardInfoLoading: true,
      };
    case GET_RETIREMENT_CARD_INFO_SUCCESS: {
      const cleaned = action?.payload?.value.replace(/\\/g, "");
      const retirementCardInfo = JSON.parse(cleaned || "{}");
      return {
        ...state,
        retirementProjectedReturn: retirementCardInfo?.projectedReturn,
        retirementInceptiondate: retirementCardInfo?.inceptionDate,
        getRetirementCardInfoLoading: false,
      };
    }
    case GET_RETIREMENT_CARD_INFO_FAILED:
      return {
        ...state,
        retirementProjectedReturn: state.retirementProjectedReturn,
        retirementInceptiondate: state.retirementInceptiondate,
        getRetirementCardInfoLoading: false,
      };
    case GET_RETIREMENT_MIN_AMOUNT:
      return {
        ...state,
        getRetirementMinAmountLoading: true,
      };
    case GET_RETIREMENT_MIN_AMOUNT_SUCCESS:
      return {
        ...state,
        getRetirementMinAmountLoading: false,
        retirementMinAmount: action.payload?.value,
      };
    case GET_RETIREMENT_MIN_AMOUNT_FAILED:
      return {
        ...state,
        getRetirementMinAmountLoading: false,
        retirementMinAmount: process.env.REACT_APP_RETIREMENT_MIN_AMOUNT.trim(),
      };
      case GET_RETIREMENT_MAX_AMOUNT:
        return {
          ...state,
          getRetirementMaxAmountLoading: true,
        };
      case GET_RETIREMENT_MAX_AMOUNT_SUCCESS:
        return {
          ...state,
          getRetirementMaxAmountLoading: false,
          retirementMaxAmount: action.payload?.value,
        };
      case GET_RETIREMENT_MAX_AMOUNT_FAILED:
        return {
          ...state,
          getRetirementMaxAmountLoading: false,
          retirementMaxAmount: process.env.REACT_APP_RETIREMENT_MAX_AMOUNT.trim(),
        };
    case UPDATE_CUSTOMER_DUPLICATE:
      return {
        ...state,
        updateCustomerDuplicateLoading: true,
      };
    case UPDATE_CUSTOMER_DUPLICATE_SUCCESS:
      return {
        ...state,
        updateCustomerDuplicateLoading: false,
      };
    case UPDATE_CUSTOMER_DUPLICATE_FAILED:
      return {
        ...state,
        updateCustomerDuplicateLoading: false,
      };
    case GET_PROJECTED_RETURN:
      return {
        ...state,
        getStartedLoading: true,
      };
    case GET_PROJECTED_RETURN_SUCCESS: {
      const cleaned = action?.payload?.value.replace(/\\/g, "");
      const MPSAVEData = JSON.parse(cleaned || "{}");
      return {
        ...state,
        saveProjectedReturnValue: MPSAVEData.projectedReturn,
        saveInceptionDate: MPSAVEData.inceptionDate,
        getStartedLoading: false,
      };
    }
    case GET_PROJECTED_RETURN_FAILED:
      return {
        ...state,
        saveProjectedReturnValue: "3.95%",
        getStartedLoading: false,
      };
    case STEP_STARTED:
      return {
        ...state,
        startedStep: action.payload,
      };
    case GET_TOTAL_UNIT_FUNDS:
      return {
        ...state,
        fundsUnitloading: true,
      };
    case GET_TOTAL_UNIT_FUNDS_SUCCESS:
      return {
        ...state,
        totalUnitFunds: action.payload,
        fundsUnitloading: false,
      };
    case GET_TOTAL_UNIT_FUNDS_FAILED:
      return {
        ...state,
        totalUnitFunds: { itemCount: 20 },
        fundsUnitloading: false,
      };
    case PROJECTED_RETURN_INVEST:
      return {
        ...state,
        investGetStartedLoading: true,
      };
    case PROJECTED_RETURN_INVEST_SUCCESS: {
      const cleaned = action?.payload?.value.replace(/\\/g, "");
      const MPINVESTData = JSON.parse(cleaned || "{}");
      return {
        ...state,
        investProjectedReturnValue: MPINVESTData.projectedReturn,
        investInceptionDate: MPINVESTData.inceptionDate,
        investGetStartedLoading: false,
      };
    }
    case PROJECTED_RETURN_INVEST_FAILED:
      return {
        ...state,
        investGetStartedLoading: false,
      };
    default:
      return state;
  }
}
